<template>
  <div class="wrapper">
    <div class="serif black hot-posts-container" :class="screenWidth>768?'mb-130':''">
      <h1 class="hot-posts-h1-title">
        {{info.posts_title}}
        <div v-if="screenWidth>768" class="default-font dis-ib fs-15 lh-16 pr lf--10">观<br>点</div>
        <div v-else class="default-font dis-ib fs-16 pr lf--2">
          观点
        </div>
      </h1>
      <h4 class="hot-posts-h4-title san-serif">{{info.posts_subtitle}}</h4>
    </div>
    <el-row :gutter="80" class="hot-posts-el-row">
      <el-col v-for="(n,idx) in postsList" :key="idx" :xs="24" :span="12">
        <div :style="offsetBottom(idx)" class="hot-posts-item pr lf-0">
          <div @click="viewItem(n)" v-observe-visibility="visibilityChanged" :class="screenWidth>1200?'transition-wrap':''" class="hot-posts-item-img graylight-bg pr">
            <div
              :style="{backgroundImage: 'url(' + n.ins_poster + ')'}"
              style="height:50%;"
              class="wi-100x silverdark-bg centerimage transition-slow pa bm-0 lf-0"></div>
          </div>
          <div class="pr op-0 bm--30 transition-slow" :class="screenWidth>768?'pt-24':'pt-14'" v-observe-visibility="postTitleVisible">
            <div class="hot-posts-item-tags">
              <span>{{n.ins_subtitle}}</span>
            </div>
            <div @click="viewItem(n)" class="hot-posts-item-title serif" :class="screenWidth<=1200?'title-mobile-text':'hover-title'">{{n.ins_title}}</div>
          </div>
        </div>
      </el-col>
    </el-row>
    <div class="ta-c hot-posts-more pr transition-slow bm-0 op-0" v-observe-visibility="seeMoreVisible">
      <span @click="router('/posts')" class="dis-ib serif" :class="screenWidth<=1200?'title-default-text':'hover-text'">
        {{info.posts_more}}
        <div v-if="screenWidth>992" class="default-font dis-ib fs-14 lh-14 pr lf--6" :class="screenWidth<=1200?'':'hover-text-more'">更<br>多</div>
        <div v-else class="default-font dis-ib fs-15 pr lf--2">更多</div>
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'hotPosts',
  computed: {
    ...mapGetters([
      'scrollHeight',
      'hotPosts',
      'hotPostList',
      'textInfo',
      'screenWidth'
    ])
  },
  data () {
    return {
      postsList: [],
      info: {}
    }
  },
  watch: {
    hotPosts (val) {
      if (val) {
        this.readPosts(this.$.s2o(val).ids)
      }
    },
    scrollHeight (val) {
      this.offsetBottom()
    },
    textInfo (val) {
      if (val) {
        this.info = this.$.s2o(val)
        this.$.s('textInfo', val)
      }
    }
  },
  mounted () {
    if (this.hotPostList) {
      this.postsList = this.$.s2o(this.hotPostList)
    }
    if (this.$.g('textInfo')) {
      this.info = this.$.s2o(this.$.g('textInfo'))
    }
  },
  methods: {
    /*
    * 查询热门文章
    */
    readPosts (ids) {
      this.postsList = []
      this.get({
        url: 'webInsightPull',
        data: {
          ids: this.$.o2s(ids)
        }
      }, (r) => {
        if (r.code) {
          this.postsList = r.data
          this.$store.commit('updateHotPostList', this.$.o2s(r.data))
        }
      })
    },
    /**
     * 查看详情
    */
    viewItem (n) {
      let routeUrl = this.$router.resolve({
        path: '/posts/' + n.id
      })
      window.open(routeUrl.href, '_blank')
    },
    /**
    * 显示更多
    */
    seeMoreVisible (isVisible, entry) {
      if (isVisible && this.screenWidth > 768) {
        entry.target.style.bottom = '70px'
        entry.target.style.opacity = '1'
      } else if (isVisible) {
        entry.target.style.bottom = '10px'
        entry.target.style.opacity = '1'
      }
    },
    /**
    * 标题显示
    */
    postTitleVisible (isVisible, entry) {
      if (isVisible) {
        entry.target.style.bottom = '0'
        entry.target.style.opacity = '1'
      }
    },
    visibilityChanged (isVisible, entry) {
      if (isVisible) {
        entry.target.firstElementChild.style.height = '100%'
      }
    },
    offsetBottom (idx) {
      let res = ''
      if (this.screenWidth < 768) {
        res = ''
      } else {
        if (idx % 2 === 1) {
          res = 'bottom: ' + (this.scrollHeight * 6 - 240) + 'px'
        } else {
          res = 'bottom: ' + (this.scrollHeight * 2 - 20) + 'px'
        }
        return res
      }
    }
  }
}
</script>
<style>
.hot-posts-el-row {
  display: flex;
  flex-wrap: wrap;
  padding-left: 20px;
  padding-right: 20px;
}
.hot-posts-h1-title {
  font-size: 2em;
  margin-bottom: 10px;
}
.hot-posts-h4-title {
  font-size: 0.9em;
  font-weight: 400;
}
.hot-posts-container {
  padding-top: 6em;
  padding-bottom: 3.5em;
  padding-left: 20px;
  padding-right: 20px;
}
.hot-posts-item {
  margin-bottom: 4em;
}
.hot-posts-item-img {
  height: 18em;
}
.hot-posts-item-tags {
  font-size: 0.875em;
}
.hot-posts-item-title {
  font-size: 1.8em;
  font-weight: 600;
}
.hot-posts-more {
  padding-top: 0.625em;
  padding-bottom: 3.5em;
  font-size: 1.625em;
  font-weight: 600;
}
@media screen and (min-width: 768px) and (max-width: 992px) {
  .hot-posts-h1-title {
    font-size: 48px;
    margin-bottom: 10px;
  }
  .hot-posts-h4-title {
    font-size: 17px;
    font-weight: 300;
  }
  .hot-posts-container {
    padding-top: 105px;
    padding-bottom: 75px;
  }
  .hot-posts-item {
    margin-bottom: 70px;
  }
  .hot-posts-item-img {
    height: 275px;
  }
  .hot-posts-item-tags {
    font-size: 15px;
  }
  .hot-posts-item-title {
    font-size: 28px;
    font-weight: 600;
  }
  .hot-posts-more {
    padding-bottom: 120px;
    font-size: 28px;
    font-weight: 600;
  }
}
@media screen and (min-width: 992px) and (max-width: 1200px) {
  .hot-posts-h1-title {
    font-size: 53px;
    margin-bottom: 10px;
  }
  .hot-posts-h4-title {
    font-size: 17px;
    font-weight: 300;
  }
  .hot-posts-container {
    padding-top: 120px;
    padding-bottom: 80px;
  }
  .hot-posts-item {
    margin-bottom: 70px;
  }
  .hot-posts-item-img {
    height: 355px;
  }
  .hot-posts-item-tags {
    font-size: 15px;
  }
  .hot-posts-item-title {
    font-size: 32px;
    font-weight: 600;
  }
  .hot-posts-more {
    padding-bottom: 120px;
    font-size: 32px;
    font-weight: 600;
  }
}
@media screen and (min-width: 1200px) and (max-width: 1920px) {
  .hot-posts-h1-title {
    font-size: 54px;
    margin-bottom: 10px;
  }
  .hot-posts-h4-title {
    font-size: 14px;
    font-weight: 400;
  }
  .hot-posts-container {
    padding-top: 145px;
    padding-bottom: 105px;
  }
  .hot-posts-item {
    margin-bottom: 80px;
  }
  .hot-posts-item-img {
    height: 440px;
  }
  .hot-posts-item-tags {
    font-size: 14px;
  }
  .hot-posts-item-title {
    font-size: 34px;
    font-weight: 600;
  }
  .hot-posts-more {
    padding-bottom: 145px;
    font-size: 38px;
    font-weight: 600;
  }
}
@media screen and (min-width: 1920px) {
  .hot-posts-h1-title {
    font-size: 58px;
    margin-bottom: 10px;
  }
  .hot-posts-h4-title {
    font-size: 16px;
    font-weight: 400;
  }
  .hot-posts-container {
    padding-top: 160px;
    padding-bottom: 120px;
  }
  .hot-posts-item {
    margin-bottom: 80px;
  }
  .hot-posts-item-img {
    height: 500px;
  }
  .hot-posts-item-tags {
    font-size: 16px;
  }
  .hot-posts-item-title {
    font-size: 38px;
    font-weight: 600;
  }
  .hot-posts-more {
    padding-bottom: 160px;
    font-size: 46px;
    font-weight: 600;
  }
}
</style>



// WEBPACK FOOTER //
// src/compos/hotPosts.vue